import React, { Component } from 'react';
import * as api from '../../api/api';
import { connect } from 'react-redux';
import { Grid, GridCell } from 'rmwc/Grid';
import { Card } from 'rmwc/Card';
import { Button } from 'rmwc/Button';
import { Typography } from 'rmwc/Typography';
import { TextField } from 'rmwc/TextField';
import { Radio } from 'rmwc/Radio';
import { Select } from 'rmwc/Select';

import StatusMessage from '../../util/StatusMessage'

class AdminQuestionnaireDetail extends Component {

  constructor(props) {
    super(props);
    this.state ={
      errorMsg: '',
      initialLoadingComplete: false,
      addUpdateDisable: false,
      data:{
        grades: [],
        subjects: [],
        selectedGrade:'',
        selectedSubject: '',
        questionnaire: '',
        id: '',
        "name": '',
        "custom_id": '',
        "questionnaire_link": '',
        "global_type_id": 3,
        "active": true,
        "created_at": '',
        "updated_at": '',
        "report_link": '',
        "report_display": '',
        "specific_display": '',
        "subject_id": '',
        "grade_id": '',
        "listing_sequence": '',
        "img_link": '',
        "questionnaire_type": '',
      },
      formErrors:{
        "nameError": '',
        "questionnaireLinkError": '',
        "customIdError": '',
        "imageLinkError": '',
        "questionnaireTypeError": '',
        "activeError": '',
        "listingSequenceError": '',
        "globalTypeError": ''
      }
    }

  }

  componentDidMount() {
    let selectedId = parseInt(this.props.match.params.id)
    let data = Object.assign({}, this.state.data)   
    let gradeURL ='grade'
    let subjectURL ='admin/subjects/lists'
    data.id = selectedId
    api.getResponse(this.props.user.accessToken, gradeURL)
    .then((result) => {
      data.grades = result.data
      return api.getResponse(this.props.user.accessToken, subjectURL)
      }).then((result) =>{
      data.subjects = result.data
      if(selectedId === 0){
        this.setState({data:data, initialLoadingComplete:true})
      }
      else{
        let QuestionnarireURL ='admin/questionnaire/details/'+selectedId
        return api.getResponse(this.props.user.accessToken, QuestionnarireURL).then((result) =>{
        data.questionnaire = result.data
        data.id = result.data.id
        data.name = result.data.name
        data.custom_id = result.data.custom_id
        data.questionnaire_link = result.data.questionnaire_link
        data.global_type_id = result.data.global_type_id
        data.active = result.data.active       
        data.report_link = result.data.report_link
        data.specific_display = result.data.specific_display
        data.subject_id = result.data.subject_id
        data.grade_id = result.data.grade_id
        data.img_link = result.data.img_link
        data.listing_sequence = result.data.listing_sequence
        data.questionnaire_type = result.data.questionnaire_type
        this.setState({data:data, initialLoadingComplete:true})
        }).catch((err) => {
          this.setState({ errorMsg: 'Exception in Fetching Details'})
        })
      }
    })
  }

  handleBackAction = (e) => {
      e.preventDefault()
      this.props.history.push('/portal/app/admin/questionnaire/home')
    }

  onInputChange = (evt) => {
    const data = Object.assign({}, this.state.data);
    data[evt.target.name] = evt.target.value;  
    this.setState({data: data});
  }

  handleActiveChange =(evt) => {
    const isSelected = evt.target.value === 'true' ? true: false
    const data = Object.assign({}, this.state.data);
    data[evt.target.name] = isSelected
    this.setState({ data })
  }

  handleGlobalTypeChange =(evt) =>{
    const data = Object.assign({}, this.state.data);
    data[evt.target.name] = parseInt(evt.target.value)
    this.setState({data:data})
  }

  handleSelectedSubject = (evt) => {
    const data = Object.assign({}, this.state.data);
    data.subject_id = evt.target.value
    this.setState({data:data})
  }

  handleSelectedGrade = (evt) => {
    const data = Object.assign({}, this.state.data);
    data.grade_id = evt.target.value
    this.setState({data:data})
  }

  validateForm = () => {
    let error = true
    let errorObj = Object.assign({}, this.state.formErrors)
    let data = Object.assign({}, this.state.data)

    errorObj.nameError = ''
    errorObj.questionnaireLinkError = ''
    errorObj.customIdError = ''
    errorObj.imageLinkError = ''
    errorObj.activeError = ''
    errorObj.listingSequenceError = ''
    errorObj.questionnaireTypeError = ''
    errorObj.globalTypeError = ''

    if(!data.name){
        errorObj.nameError ='Name is mandatory'
        error = false
    }

     if(!data.img_link){
        errorObj.imageLinkError ='Logo Link is mandatory'
        error = false
    }

     if(!data.custom_id){
        errorObj.customIdError ='CustomId is mandatory and should be Unique'
        error = false
    }

     if(!data.questionnaire_link){
        errorObj.questionnaireLinkError ='Questionniare Link is mandatory'
        error = false
    }

     if(data.active === null || data.active === undefined || data.active === ''){
        errorObj.activeError ='Status is mandatory'
        error = false
    }

    if(!data.global_type_id){
        errorObj.globalTypeError ='Questionnaire Category Survey/Quiz is mandatory'
        error = false
    }

    if(!data.listing_sequence){
        errorObj.listingSequenceError ='Listing Sequence is mandatory'
        error = false
    }

    else if(data.listing_sequence > 99.999){
      errorObj.listingSequenceError = 'Listing Sequence cannot be greater than 99.999'
      error = false
    }

      if(!data.questionnaire_type){
        errorObj.questionnaireTypeError ='Questionniare Type is mandatory'
        error = false
      }

      else if((data.global_type_id === 3) && (data.questionnaire_type !== 'Survey')){
        errorObj.questionnaireTypeError ='Questionniare Type should be Survey'
        error = false
      }

      else if(data.global_type_id === 4) {
        if((data.questionnaire_type !== 'General') && (data.questionnaire_type !== 'Subject')){
          errorObj.questionnaireTypeError ='Questionniare Type Should be General or Subject'
          error = false
        }
      }

      else if((data.questionnaire_type !== 'General') && (data.questionnaire_type !== 'Subject') && (data.questionnaire_type !== 'Survey')){
        errorObj.questionnaireTypeError ='Questionniare Type should contain either General,Subject or Survey as their Type'
        error = false
      }

      
    this.setState({formErrors:errorObj, errorMsg:''})
    return error

  }

  handleAddQuestionnaire = (e) => {
    e.preventDefault()
    if(this.validateForm()){
      let url = 'admin/create/questionnaires'
      let apiInput = {
        'id': this.state.data.id,
        'name': this.state.data.name,
        'custom_id': this.state.data.custom_id.trim(),
        'global_type_id':this.state.data.global_type_id,
        'questionnaire_link':this.state.data.questionnaire_link,
        'img_link': this.state.data.img_link,
        'active': this.state.data.active,
        'listing_sequence': this.state.data.listing_sequence,
        'subject_id': this.state.data.subject_id,
        'grade_id': this.state.data.grade_id,
        'questionnaire_type': this.state.data.questionnaire_type
      }
      api.postValuesApi(this.props.user.accessToken, url, apiInput)
      .then((result) => {
        
        if(result.status === 'success'){
          this.setState({ errorMsg: result.message, addUpdateDisable: true })
        } 
        else{
          this.setState({ errorMsg: result.data })
        }    
        
      })
      .catch((err) => {
        this.setState({ errorMsg: err.stack })
      })
    }
  }

  handleUpdateQuestionnaire = (e) => {
    e.preventDefault()

    if(this.validateForm()){
      let url = 'admin/update/questionnaire/'+this.state.data.id
      let apiInput = {
        'id': this.state.data.id,
        'name': this.state.data.name,
        'custom_id': this.state.data.custom_id,
        'global_type_id':this.state.data.global_type_id,
        'questionnaire_link':this.state.data.questionnaire_link,
        'img_link': this.state.data.img_link,
        'active': this.state.data.active,
        'listing_sequence': this.state.data.listing_sequence,
        'subject_id': this.state.data.subject_id,
        'grade_id': this.state.data.grade_id,
        'questionnaire_type': this.state.data.questionnaire_type
      }
      api.putValuesApi(this.props.user.accessToken, url, apiInput)
      .then((result) => {
        
        if(result.status === 'success'){
          this.setState({ errorMsg: result.message, addUpdateDisable: true })
        } 
        else{
          this.setState({ errorMsg: result.data })
        }    
        
      })
      .catch((err) => {
        this.setState({ errorMsg: err.stack })
      })
    }
  }
 

  render() {
    let subjectSelectionComponent
    let gradeSelectionComponent   
    let buttonComponent
    let globalTypeComponent
    let customIdComponent
    let questionnaireLinkComponent
    let noteComponent
    let infoComponent

    if(this.state.data.id === 0){
      buttonComponent=<Button raised onClick={this.handleAddQuestionnaire} disabled={this.state.addUpdateDisable}>Add</Button>
      
      noteComponent = (
        <GridCell span="12">
          <Typography use="subtitle"><b>Note:</b> Please ensure that the webhook is configured inorder to capture the Questionniare scores.</Typography>
        </GridCell>
        )

      globalTypeComponent = (
        <GridCell>
          <Radio name="global_type_id" value='3' checked={this.state.data.global_type_id === 3} onChange = {this.handleGlobalTypeChange}>
            Survey
          </Radio>
          <Radio  name="global_type_id" value='4' checked={this.state.data.global_type_id === 4} onChange = {this.handleGlobalTypeChange}>
            Sample Quiz
          </Radio>
        </GridCell>
        )

      customIdComponent = (
          <TextField  className='text_input' label="Custom Id" autoComplete="off" name="custom_id" onChange={this.onInputChange} value={this.state.data.custom_id}  />
        )
      questionnaireLinkComponent = (<TextField fullwidth  className='text_input' label="Questionniare Link" autoComplete="off" name="questionnaire_link" onChange={this.onInputChange} value={this.state.data.questionnaire_link}/>
        )

    }

    else if (this.state.data.id > 0){
      buttonComponent=<Button raised onClick={this.handleUpdateQuestionnaire} disabled={this.state.addUpdateDisable}>Update</Button>

      globalTypeComponent = (
        <GridCell>
          <Radio name="global_type_id" value='3' disabled = {true} checked={this.state.data.global_type_id === 3}>
            Survey
          </Radio>
          <Radio  name="global_type_id" value='4' disabled = {true} checked={this.state.data.global_type_id === 4}>
            Sample Quiz
          </Radio>
        </GridCell>
        )

      customIdComponent = (<TextField  disabled className='text_input' label="Custom Id" autoComplete="off" name="custom_id" value={this.state.data.custom_id}/>
        )
      questionnaireLinkComponent = (<TextField fullwidth disabled className='text_input' label="Questionniare Link" autoComplete="off" name="questionnaire_link" value={this.state.data.questionnaire_link}/>
        )
    }

    subjectSelectionComponent = ( 
     <Select 
        name = "Subject"
        onChange={this.handleSelectedSubject}
        value={this.state.data.subject_id}
        
      >
        <option value="" selected = "">--Please Select Subject--</option>
        {this.state.data.subjects.map(sub => (
          <option key={sub.id} value={sub.id} name={sub.name}>
            {sub.name}
          </option>
        ))}
      </Select>
    )

    gradeSelectionComponent = (
      <Select
        name = "Grade"
        onChange = {this.handleSelectedGrade}
        value = {this.state.data.grade_id}
        >
        <option value ="" selected="" >--Please Select Grade--</option>
        {this.state.data.grades.map(grade => (
          <option key = {grade.value} value = {grade.value} name = {grade.label}>
          {grade.label}
          </option>
          ))}
      </Select>
    )

    infoComponent = (
      <GridCell span="12">
        <Typography use="caption"><b>Listing Sequence:</b> Value cannot be greater than 99.999.</Typography><br/>
        <Typography use="caption"><b>Questionniare Type:</b> Please type Survey for Survey. General or Subject for Sample Quiz.</Typography>
      </GridCell>
      )
      

    return(
      <div>
        <Grid>
          <GridCell span="12">
            <Card style={{padding: '25px'}}>
              <Typography use="headline6">Sample Quiz/Survey Details</Typography>
            </Card>
          </GridCell>
        </Grid>         
        <Grid>
            <GridCell span = "5">
              <TextField  className='text_input' label="Name" autoComplete="off" name="name" onChange={this.onInputChange} value={this.state.data.name}/>
            </GridCell>
            <GridCell span = "6">
              {customIdComponent}
             </GridCell>
            <GridCell span = "1">
                <Button raised onClick = {((e) => this.handleBackAction(e))}>Back</Button>
          </GridCell>

          <GridCell span="12">
            {questionnaireLinkComponent}
          </GridCell>

          <GridCell span="12">
           <TextField fullwidth className='text_input' label="Logo Link" autoComplete="off" name="img_link" onChange={this.onInputChange} value={this.state.data.img_link}/>
          </GridCell>   
   
          <GridCell span="5">
            <Radio name="active" value={true} checked={this.state.data.active} onChange={this.handleActiveChange}>
              Active
            </Radio>
            <Radio  name="active" value={false} checked={!this.state.data.active} onChange={this.handleActiveChange}>
              Inactive
            </Radio>
          </GridCell>

          <GridCell span="2"/>

          <GridCell span="5">
            {globalTypeComponent}
          </GridCell> 

          <GridCell span = "6">
            {subjectSelectionComponent}
          </GridCell>

          <GridCell span ="6">
            {gradeSelectionComponent}
          </GridCell>

          <GridCell span = "6">
            <TextField className='text_input' label="Listing Sequence" autoComplete="off" name="listing_sequence" type="number" onChange={this.onInputChange} value={this.state.data.listing_sequence}/>
          </GridCell>

          <GridCell span = "6">
           <TextField className='text_input' label="Questionnaire Type" autoComplete="off" name="questionnaire_type" onChange={this.onInputChange} value={this.state.data.questionnaire_type}/>
          </GridCell>
          {infoComponent}
          {noteComponent}
          <div>
              <GridCell span="12">
                {buttonComponent}
              </GridCell>
          </div>
          <br/>
          </Grid>
          <div>
            <GridCell span="12">
              <StatusMessage error_msg = {this.state.errorMsg}/>
              <StatusMessage error_msg = {this.state.formErrors.nameError}/>
              <StatusMessage error_msg = {this.state.formErrors.questionnaireLinkError}/>
              <StatusMessage error_msg = {this.state.formErrors.customIdError}/>
              <StatusMessage error_msg = {this.state.formErrors.imageLinkError}/>
              <StatusMessage error_msg = {this.state.formErrors.questionnaireTypeError}/>
              <StatusMessage error_msg = {this.state.formErrors.activeError}/>
              <StatusMessage error_msg = {this.state.formErrors.globalTypeError}/>
              <StatusMessage error_msg = {this.state.formErrors.listingSequenceError}/>
            </GridCell>
          </div>
      </div>
      );
  }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminQuestionnaireDetail);


// WEBPACK FOOTER //
// ./src/views/admin/AdminQuestionnaireDetail.jsx